<img [src]="imageSrc" [width]="imageWidth" [height]="imageHeight" alt="">
